import { AlwApi } from 'api';
import { useCallback, useEffect, useState } from 'react';
import { AlwLadderItem, AlwSupportedGamesIds, LadderAdditionalInfo } from '../types';

export const useAlwLeaderboard = () => {
    const [ladderFetching, setLadderFetchingState] = useState(true);
    const [ladderError, setLadderErrorState] = useState(false);

    const [ladderChosenGame, setLadderChosenGame] = useState<AlwSupportedGamesIds>(21640);
    const [ladder, setAlwLadder] = useState<AlwLadderItem[]>([]);
    const [ladderInfo, setLadderInfo] = useState<Omit<LadderAdditionalInfo, 'isLoadingMore'>>({
        currentPage: 1,
        more: true,
    });

    const loadMore = async () => {
        try {
            const data = await AlwApi.getAlwLadder(
                ladderChosenGame,
                ladderInfo.currentPage * 100,
                100,
            );

            if (data.error || !data.success) throw new Error(data.error);

            setAlwLadder([...ladder, ...data.data.ladder]);
            setLadderInfo({ more: data.data.more, currentPage: ladderInfo.currentPage + 1 });
        } catch (error) {
            setLadderErrorState(true);
            setAlwLadder([]);
        }
    };

    const fetchAlwLadder = useCallback(async () => {
        try {
            setLadderFetchingState(true);
            setAlwLadder([]);

            const data = await AlwApi.getAlwLadder(ladderChosenGame);

            if (data.error || !data.success) throw new Error(data.error);

            setAlwLadder(data.data.ladder);
            setLadderInfo({ more: data.data.more, currentPage: 1 });
        } catch (error) {
            setLadderErrorState(true);
            setAlwLadder([]);
        } finally {
            setLadderFetchingState(false);
        }
    }, [ladderChosenGame]);

    useEffect(() => {
        fetchAlwLadder();
    }, [fetchAlwLadder]);

    return {
        ...ladderInfo,
        ladder,
        ladderFetching,
        ladderChosenGame,
        ladderError,
        loadMore,
        fetchAlwLadder,
        setLadderChosenGame,
    };
};
